import React, { useState, useContext, useCallback } from "react";
import PropTypes from "prop-types";
import ActionTabs from "components/CaseManagement/CaseDetail/Action/ActionTabs";
import ActionList from "components/CaseManagement/CaseDetail/Action/ActionList";
import { AddActionButton } from "components/CaseManagement/AddActionButton";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { CaseActionsContext } from "contexts/CaseActionsContext";

const OPEN = 0;

export default function ActionWrapper({ caseId }) {
  const [tabStatus, setTabStatus] = useState(OPEN);
  const [sortType, setSortType] = useState("date");

  const { loading, error, actions, refetchActions } = useContext(
    CaseActionsContext
  );

  const changeActionTabStatus = tabStatus => {
    setTabStatus(tabStatus);
  };

  const changeSortType = useCallback(() => {
    sortType === "status" ? setSortType("date") : setSortType("status");
  }, [sortType]);

  let sortedActions = [...actions];

  if (sortType === "date") {
    sortedActions.sort((a, b) => {
      // if both are not null compare the dates
      if (
        a.requested_completion_date !== null &&
        b.requested_completion_date !== null
      ) {
        return new Date(a.requested_completion_date) >
          new Date(b.requested_completion_date)
          ? 1
          : -1;
      }
      // if only a is not null, sort a before b
      else if (a.requested_completion_date !== null) {
        return -1;
      }
      // if only b is not null, sort b before a
      else {
        return 1;
      }
    });
  } else {
    sortedActions.sort(
      (a, b) => a.action_status_detail.order - b.action_status_detail.order
    );
  }

  return (
    <>
      <ActionTabs
        changeActionTabStatus={changeActionTabStatus}
        tabStatus={tabStatus}
      />
      <ActionButtonsWrapper>
        <AddActionButton
          caseId={caseId}
          addNewAction={() => refetchActions()}
          data-qa="CP-Button-Add-Action"
        />
        <SortActionButton
          onClick={changeSortType}
          color="primary"
          data-qa="CP-Button-Sort-Actions"
        >
          Sort by {sortType === "status" ? "Due Date" : "Status"}
        </SortActionButton>
      </ActionButtonsWrapper>
      <ActionListContainer>
        <ActionList
          loading={loading}
          error={error}
          actions={sortedActions}
          tabStatus={tabStatus}
          caseId={caseId}
          removeAction={() => refetchActions()}
          replaceExistingAction={() => refetchActions()}
        />
      </ActionListContainer>
    </>
  );
}

ActionWrapper.propTypes = {
  caseId: PropTypes.number.isRequired
};

const ActionListContainer = styled("div")`
  margin-top: 15px;
`;

const SortActionButton = styled(Button)`
  text-transform: none;
`;

const ActionButtonsWrapper = styled("div")`
  display: flex;
  justify-content: space-between;
`;
